webpackJsonp([8],{

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__(300);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f84810_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__(343);
var normalizeComponent = __webpack_require__(89)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f84810_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      team: [{ names: 'Winner Musole', position: 'PDG', biography: 'Il est le co-fondateur et actuel du PDG de Ligablo Food, mais aussi directeur financier chez Pynlabs Uganda. Winner vient d’obtenir son baccalauréat en informatique de International University of East Africa, Kampala, en Ouganda avec un mémoire orienté sur le marché boursier.', photo: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/teamPhoto%2Fwinner.jpg?alt=media&token=04e244e3-ab0b-4060-868d-6f22e14b49a6', twitterRef: 'https://twitter.com/musolemasu', twitterName: 'MusoleMasu' }, { names: 'Gueldany Panzu', position: 'Associé-Gérant', biography: "Il est co-fondateur et l'actuel gérant de Ligablo Food. Gueldany est un analyste programmeur, étudiant en Informatique à l'université de Kinshasa et Entrepreneur.", photo: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/teamPhoto%2Fgueldany_optimized.jpeg?alt=media&token=daed96f8-cb01-4b28-aa0d-d24c8073f7e1', twitterRef: 'https://twitter.com/gueldany', twitterName: 'GuelanyPanzu' }, { names: 'Delphine Musole', position: 'Chargée des finances', biography: 'Co-fondatrice de Ligablo Food. Delphine Musole fait la Science economique à Université Federal de Rio de Janeiro au Bresil.', photo: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/teamPhoto%2Fdelphine.jpeg?alt=media&token=68073003-69f5-4f92-b773-f56a4ee38e10', twitterRef: 'https://twitter.com/musolemasu', twitterName: 'DelphineMusole' }, { names: 'Sebastien Wendji', position: 'Conseiller', biography: "Sebastien Wendji est un jeûne  entrepreneur congolais, co-fondateur de LigabloFood et actuellement étudiant de la faculté des sciences pharmaceutiques de l'université de Kinshasa.", photo: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/teamPhoto%2Fsebastien.jpg?alt=media&token=786815f8-82d8-4178-bc66-48d3d4633dc8', twitterRef: 'https://twitter.com/musolemasu', twitterName: 'DelphineMusole' }]
    };
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-size":"48px"}},[_vm._v("Rencontrez l'équipe")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},_vm._l((_vm.team),function(item,index){return _c('v-flex',{key:index,staticClass:"mt-3",attrs:{"xs12":"","md6":"","flexbox":"","d-flex":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":"","md5":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-card-media',{attrs:{"height":"200px","src":item.photo}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","md7":""}},[_c('span',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(item.names))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"blue-grey--text darken-4",staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(item.position))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(item.biography))])])],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.3c4758c70d82055559df.js